import React, { Component } from "react";

class MajorRules extends Component {
  render() {
    return (
      <div className='showMore-rules'>
        <div className='header'>
          <img
            className='arrowDarkHeader'
            src='/public/assets/icons/arrow -right.svg'
            onClick={() => {
              this.props.history.goBack();
            }}
          alt="pic"/>
          <span>خرید عمده | کاچار</span>
        </div>
        <iframe
          src='https://kacharlife.com/major/rules'
          seamless
          style={{ border: "none", height: "90vh", width: "100vw" }}
          allow='fullscreen'
        title="kacharlife"/>
      </div>
    );
  }
}
export default MajorRules;
